export const GroupBy=(array, property)=> {
  return array.reduce(function (acc, obj) {
      var key = obj[property];
      if (!acc[key]) {
          acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
  }, {});
}